// utils/animations.ts
import type {Variants} from 'framer-motion';

export const fadeInUp = {
    hidden: {opacity: 0, y: 20},
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut'
        }
    }
} as Variants;

export const fadeIn = {
    hidden: {opacity: 0},
    visible: {
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: 'easeOut'
        }
    }
} as Variants;

export const scaleUp = {
    hidden: {opacity: 0, scale: 0.9},
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.5,
            ease: 'easeOut'
        }
    }
} as Variants;

export const slideInFromLeft = {
    hidden: {opacity: 0, x: -50},
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut'
        }
    }
} as Variants;

export const slideInFromRight = {
    hidden: {opacity: 0, x: 50},
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut'
        }
    }
} as Variants;
